import { useTranslation } from "react-i18next";
import { Box, Typography } from "@mui/material";

const VideoInstructions = ({ instructions }: { instructions: string }) => {
  const { t } = useTranslation("goService", { keyPrefix: "programVideoDetailsPage" });

  return (
    <Box sx={styles.container}>
      <Typography sx={styles.title}>{t("videoInstructions")}</Typography>
      <Typography sx={styles.instructions}>{instructions}</Typography>
    </Box>
  );
};

export default VideoInstructions;

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: "8px",
  },
  title: {
    fontFamily: "Montserrat",
    color: "var(--Gray-900, #1D2026)",
    textAlign: "center",
    fontSize: "18px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "28px",
  },
  instructions: {
    fontFamily: "Montserrat",
    color: "var(--Gray-700, #4E5566)",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "20px",
  },
};
